import * as InventoryReducer from './InventoryReducer';
import * as InventoryActions from './InventoryActions';

export {
  InventoryReducer,
  InventoryActions,
}


// WEBPACK FOOTER //
// ./src/modules/inventory/index.js